'use client';

import { c as _c } from "react/compiler-runtime";
import { FetchErrorBoundary } from '@/app/error-boundary';
type Props = {
  error: Error;
  reset: () => void;
};
export default function Error(t0) {
  const $ = _c(3);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] !== error || $[1] !== reset) {
    t1 = <FetchErrorBoundary error={error} reset={reset} />;
    $[0] = error;
    $[1] = reset;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}